import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoginFormFactory } from '@app/modules/public/login/factories/forms/login-form.factory';
import { ApplicationModule, NavigationType } from '@shared-libs/enums';
import { IFormGroup, ILoginCredentials } from '@shared-libs/interfaces';
import { UserManager } from '@shared-managers/user.manager';
import { AuthenticationService } from '@shared-services/authentication.service';
import { NavigationService } from '@shared-services/navigation.service';
import { BasePage } from '@shared-pages/base.page';

@Component({
	selector: 'login-page',
	templateUrl: 'login.page.html',
	styleUrls: ['login.page.scss'],
})
export class LoginPage extends BasePage implements OnInit {
	public credentialsForm: IFormGroup<ILoginCredentials>;
	public passwordType: 'password' | 'text' = 'password';
	public duplicateLogos: Array<string> = ['', ''];
	public logos: Array<string> = [
		'baldemore.jpg',
		'beringen.jpg',
		'digistroom.jpg',
		'halle.jpg',
		'hasselt.jpg',
		'kina.jpg',
		'lier.jpg',
		'machelen.jpg',
		'neteland.jpg',
		'noorderkempen.jpg',
		'rupelaar.jpg',
		'sintniklaas.jpg',
		'vilvoorde.jpg',
		'w13.jpg',
		'zuiderkempen.jpg',
	];

	constructor(
		private readonly route: ActivatedRoute,
		public readonly authenticationService: AuthenticationService,
		private readonly navigationService: NavigationService,
		private readonly userManager: UserManager
	) {
		super();
	}

	public ngOnInit(): void {
		void this.initialize();
		this.route.url.subscribe(() => {
			void this.initialize();
		});
	}

	public login(): void {
		if (this.credentialsForm.valid) {
			this.authenticationService.login(LoginFormFactory.getValue(this.credentialsForm));
		}
	}

	public navigateToResetPassword(): void {
		void this.navigationService.navigateTo(NavigationType.page, '/reset').catch();
	}

	public navigateToRegisterTenant(): void {
		void this.navigationService.navigateTo(NavigationType.page, '/digibank-registreren').catch();
	}

	public showPassword(): void {
		if (this.passwordType === 'password') {
			this.passwordType = 'text';
		} else this.passwordType = 'password';
	}

	private async initialize(): Promise<void> {
		if ((await this.authenticationService.isAuthenticated()) && !this.navigationService.previousPageInternal()) {
			this.authenticationService.navigateToApplicationModule(ApplicationModule.Internal);
		} else {
			this.credentialsForm = LoginFormFactory.create();
		}
	}
}
